module.exports = __webpack_public_path__ + "36cce6bb248a123346566f686324c1b6.png";